import {Slider, withStyles} from '@material-ui/core'

export const styles = () => ({
  sliderContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  partyRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
  },
  partyLabel: {
    fontSize: 14,
    color: '#4F4F4F',
    fontWeight: 500,
  },
  percentageInput: {
    '& input': {
      textAlign: 'center',
      fontSize: 16,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #BDBFC2',
      borderRadius: 8,
    },
  },
  percentageLabel: {
    fontSize: 12,
    color: '#4F4F4F',
    fontWeight: 600,
  },
  sliderSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  },
})

export const StyledSlider = withStyles({
  root: {
    height: 8,
  },
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: 'currentColor',
    marginTop: -8,
    marginLeft: -10,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider)
